module.exports = __webpack_public_path__ + "static/media/Intro.8c0c2668.png";